import type { BudgetCategory } from '../types/budget';

export const defaultBudgetCategories: BudgetCategory[] = [
  {
    id: '',
    user_id: '',
    name: 'Venue',
    allocated: 0,
    spent: 0,
    color: 'bg-pink-500',
    icon_name: 'MapPin',
    description: 'Reception and ceremony venue costs'
  },
  {
    id: '',
    user_id: '',
    name: 'Catering',
    allocated: 0,
    spent: 0,
    color: 'bg-blue-500',
    icon_name: 'Utensils',
    description: 'Food and beverage service'
  },
  {
    id: '',
    user_id: '',
    name: 'Photography',
    allocated: 0,
    spent: 0,
    color: 'bg-green-500',
    icon_name: 'Camera',
    description: 'Wedding photography and videography'
  },
  {
    id: '',
    user_id: '',
    name: 'Flowers & Decor',
    allocated: 0,
    spent: 0,
    color: 'bg-purple-500',
    icon_name: 'Flower',
    description: 'Floral arrangements and decorations'
  },
  {
    id: '',
    user_id: '',
    name: 'Music & Entertainment',
    allocated: 0,
    spent: 0,
    color: 'bg-yellow-500',
    icon_name: 'Music',
    description: 'DJ, band, and entertainment services'
  },
  {
    id: '',
    user_id: '',
    name: 'Attire',
    allocated: 0,
    spent: 0,
    color: 'bg-indigo-500',
    icon_name: 'Shirt',
    description: 'Wedding dress, suit, and accessories'
  },
  {
    id: '',
    user_id: '',
    name: 'Transportation',
    allocated: 0,
    spent: 0,
    color: 'bg-red-500',
    icon_name: 'Car',
    description: 'Wedding day transportation'
  },
  {
    id: '',
    user_id: '',
    name: 'Gifts & Favors',
    allocated: 0,
    spent: 0,
    color: 'bg-teal-500',
    icon_name: 'Gift',
    description: 'Wedding favors and gifts'
  },
  {
    id: '',
    user_id: '',
    name: 'Beauty & Wellness',
    allocated: 0,
    spent: 0,
    color: 'bg-rose-500',
    icon_name: 'Sparkles',
    description: 'Hair, makeup, and spa services'
  },
  {
    id: '',
    user_id: '',
    name: 'Other',
    allocated: 0,
    spent: 0,
    color: 'bg-gray-500',
    icon_name: 'MoreHorizontal',
    description: 'Miscellaneous wedding-related expenses'
  }
];

export const budgetTips = [
  {
    category: 'Venue',
    tip: 'Venue costs typically account for 40-50% of your total budget. Consider off-peak dates for savings.'
  },
  {
    category: 'Catering',
    tip: 'Food and drinks usually cost 25-35% of your budget. Buffet style can be more cost-effective than plated meals.'
  },
  {
    category: 'Photography',
    tip: 'Photography is an investment you\'ll treasure forever. Allocate 10-15% of your budget for quality coverage.'
  },
  {
    category: 'Flowers & Decor',
    tip: 'Use seasonal flowers and repurpose ceremony decorations for reception to maximize your floral budget.'
  }
];